import React from 'react';
import { useTranslation } from 'react-i18next';
import { accessPolicies } from 'prodivers/managerProfile/constants';

import { useManagerProfile } from '../../prodivers/managerProfile';

import DawReport from './items/DawReport';
import InvestmentDataReport from './items/InvestmentDataReport';
import RetentionReportOfSentDocs from './items/RetentionReportOfSentDocs';
import RetentionReportOfSubmittedOrders from './items/RetentionReportOfSubmittedOrders';
import FollowUpInvestorProfileReport from './items/FollowUpInvestorProfileReport';
import CreditMaproReport from './items/CreditMaproReport';
import RecommendedStrategyDeviatedApplicationsReport from './items/RecommendedStrategyDeviatedApplicationsReport';

import './Reports.css';

const Reports:React.FC = () => {
    const { t } = useTranslation();
    const { hasAccessPolicy } = useManagerProfile();

    return (
        <div className="container reports">
            {hasAccessPolicy(accessPolicies.Reports) && (
                <>
                    <DawReport/>
                    <InvestmentDataReport />
                    <RetentionReportOfSentDocs />
                    <RetentionReportOfSubmittedOrders />
                    <FollowUpInvestorProfileReport />
                    <CreditMaproReport />
                    <RecommendedStrategyDeviatedApplicationsReport />
                </>
            )}
            <div className="no-reports">{t('generalReports.noReports')}</div>
        </div>
    );
};

export default Reports;
